import Vue from 'vue';
import VueSocketIO from 'vue-socket.io-extended';
import io from 'socket.io-client';
import store from '@app/plugins/vuex';
import { NOTIFY_SOCKET_IO } from '@shared/helpers/env';

if (NOTIFY_SOCKET_IO.length) {
  Vue.use(
    VueSocketIO,
    io(NOTIFY_SOCKET_IO, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      withCredentials: false
    }),
    { store }
  );
} else {
  console.error('NOTIFY_SOCKET_IO is required');
}

export default io;
